interface AssetLocationPanelProps {
    latitude: number,
    longitude: number,
    deviceName: string
}

const AssetLocationPanel: React.FC<AssetLocationPanelProps> = ({ latitude, longitude, deviceName }) => {
    const bingLocationLink = "https://www.bing.com/maps/" +
        (!latitude && !longitude ? "" : `search?q=${encodeURIComponent(longitude)}%2C${encodeURIComponent(latitude)}`);

    const googleLocationLink = "https://www.google.com/maps/" +
        (!latitude && !longitude ? "" : `place/${encodeURIComponent(longitude)}+${encodeURIComponent(latitude)}`);

    return (
        <div className="d-flex flex-row">
            <a className="mr-2" href={bingLocationLink} target="_blank">View On Bing Maps</a>
            <a className="ml-2" href={googleLocationLink} target="_blank">View On Google Maps</a>
        </div>
    );
};

export default AssetLocationPanel;